import { createContext, useContext } from 'react';
export var FormGroupContext = createContext({ disabled: false });
/**
 * Helper hook to abstract needing to import the FormGroupContext yourself
 */
export function useFormGroupContext() {
    return useContext(FormGroupContext);
}
